var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0V3z",
    fill: "#ded307"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.207 4.793a1 1 0 0 0-1.414 1.414l1 1a1 1 0 0 0 1.414-1.414l-1-1z",
    fill: "#ded307"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.207 6.207a1 1 0 0 0-1.414-1.414l-1 1a1 1 0 0 0 1.414 1.414l1-1z",
    fill: "#ded307"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6a6 6 0 0 0-3.317 11h6.634A6 6 0 0 0 12 6z",
    fill: "#edbf28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H9v1a3 3 0 1 0 6 0v-1z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H3z",
    fill: "#ded307"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2h-1z",
    fill: "#ded307"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.3e6b2c6b8f2c11e642ced678b41316f0.svg";
export { ForwardRef as ReactComponent };